<template>
    <div class="submit-form">
      <el-dialog
        :title="title"
        :visible.sync="visible"
        width="40%"
        :before-close="beforeClose">
        <el-form ref="form" :model="formData" :rules="rules" label-width="120px" style="margin-right: 40px">
          <el-form-item v-for="item in items" :key="item.key" :label="item.label" :prop="item.prop">
            <el-input
              v-if="item.type == 'input'"
              v-model="formData[item.name]"
              :disabled="item.disabled"
              :placeholder="item.placeholder?item.placeholder:('请填写'+item.label)">
            </el-input>
            <el-select
              v-if="item.type == 'select'"
              style="width: 100%"
              :multiple="item.multiple"
              :disabled="item.disabled"
              v-model="formData[item.name]"
              :placeholder="item.placeholder?item.placeholder:('请选择'+item.label)"
              @change="handleSelectChange(item,$event)">
              <el-option
                v-for="option in item.options"
                :key="option.value"
                :label="option.label"
                :value="option.value">
              </el-option>
            </el-select>
            <el-checkbox-group
              v-if="item.type == 'checkbox'"
              :disabled="item.disabled"
              v-model="formData[item.name]">
              <el-checkbox
                v-for="option in item.options"
                :key="option.value"
                :label="option.value">
                {{option.label}}
              </el-checkbox>
            </el-checkbox-group>
            <el-input
              v-if="item.type == 'textarea'"
              :disabled="item.disabled"
              v-model="formData[item.name]"
              type="textarea"
              :rows="item.rows?item.rows:2"
              :placeholder="item.placeholder?item.placeholder:('请填写'+item.label)"
            ></el-input>
            <el-input-number
              v-if="item.type == 'number'"
              :disabled="item.disabled"
              v-model="formData[item.name]"
              :placeholder="item.placeholder?item.placeholder:('请填写'+item.label)"
              :precision="item.precision"
              :step="item.step ? item.step:1"
              :max="item.max"
              :min="item.min"
            >
            </el-input-number>
            <el-radio-group
              v-if="item.type == 'radio'"
              :disabled="item.disabled"
              v-model="formData[item.name]">
              <el-radio
                v-for="option in item.options"
                :key="option.value"
                :label="option.value"
              >
                {{option.label}}
              </el-radio>
            </el-radio-group>
            <el-upload
              action="#"
              v-if="item.type == 'upload'"
              :multiple="item.multiple == undefined ? false : item.multiple"
              :limit="item.limit?item.limit:1"
              list-type="picture-card"
              :auto-upload="false"
              :on-change="handleUploadSuccess"
              :on-remove="handleRemove"
              :file-list="fileImageList">
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
            <el-upload
              action="/api/sysConfig/upload"
              v-if="item.type == 'uploadAuto'"
              :multiple="item.multiple == undefined ? false : item.multiple"
              :limit="item.limit?item.limit:1"
              list-type="picture-card"
              :auto-upload="true"
              :on-success="(response,file,fileList) => { handleUploadAutoSuccess(item.name,response,file,fileList)}"
              :on-remove="(file,fileList) => {handleUploadAutoRemove(item.name,file,fileList)}"
              :file-list="item.fileImageList">
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
            <quill-editor
              v-if="item.type == 'editor'"
              v-model="formData[item.name]"
              ref="myQuillEditor"
              :options="item.editorOption">
            </quill-editor>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="beforeClose">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </span>
      </el-dialog>
    </div>
</template>

<script>
  import utils from '../../utils/utils'
    export default {
      name: "submit-form",
      props:{
        title:{
          type:String,
          default:"标题"
        },
        visible:{
          type:Boolean,
          default:false
        },
        handleClose:{
          type:Function,
          default:() => {
            return false;
          }
        },
        formData:{
          type:Object,
          default:() => {
            return {};
          }
        },
        rules:{
          type:Object,
          default:() => {
            return {};
          }
        },
        items:{
          type:Array,
          default:() => {
            return [];
          }
        },
        action:{
          type:String,
          default:""
        },
        addUrl:{
          type:String,
          default:""
        },
        updateUrl:{
          type:String,
          default:""
        },
        onSubmitCallback:{
          type:Function,
          default:() => {
            return false;
          }
        },
        onBeforeSubmit:{
          type:Function,
          default:() => {
            return false;
          }
        },
        fileImageList:{
          type:Array,
          default:() => {
            return [];
          }
        }
      },
      data(){
        return{
          uploadFile:null
        }
      },
      methods:{
        beforeClose(){
          if(typeof this.handleClose == "function"){
            this.handleClose();
          }
          this.uploadFile = null;
          this.$emit('update:visible', false)
        },
        submitForm(){
          this.$refs["form"].validate((valid) => {
            if (valid) {
              if( typeof this.onBeforeSubmit == "function"){
                this.onBeforeSubmit(this.formData)
              }
              let url,formData = new FormData();
              for(let name in this.formData){
                formData.append(name,this.formData[name]);
              }
              if(this.uploadFile){
                formData.append("files",this.uploadFile)
              }
              if(this.action == "add"){
                url = this.addUrl;
              }else{
                url = this.updateUrl;
              }
              const loading = this.$loading({
                lock: true,
                text: '加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0)'
              });
              utils.axiosMethods({
                method:"POST",
                data:formData,
                url:url,
                callback:(res => {
                  loading.close()
                  if(res.data.code == 0){
                    if(typeof this.onSubmitCallback == "function"){
                      this.onSubmitCallback()
                    }
                    this.beforeClose();
                    this.$message.success(res.data.msg);
                  }else{
                    this.$message.error(res.data.msg);
                  }
                }),
                catch:(error => {
                  loading.close();
                  this.$message.error(error.response.data.message)
                })
              })
            }
          })
        },
        //图片上传方法
        handleUploadSuccess(file, fileList){
          this.uploadFile = file.raw;
        },
        handleUploadAutoSuccess(name,response,file,fileList){
          let fileUrl = [];
          fileList.forEach(item => {
            fileUrl.push(item.response);
          })
          this.formData[name] = fileUrl.join(";");
        },
        handleUploadAutoRemove(name,file,fileList){
          let fileUrl = [];
          fileList.forEach(item => {
            fileUrl.push(item.response);
          })
          this.formData[name] = fileUrl.join(";");
          // 删除原有图片
          utils.axiosMethods({
            method: "POST",
            url: "/upload/sysConfig/deletefile",
            params: {
              url:file.response?file.response:file.url
            }
          })
        },
        handleRemove(file) {
          this.uploadFile = null;
          this.$emit('update:fileImageList', [])
        },
        handleSelectChange(item,val){
          if(typeof item.onChange === "function"){
            item.onChange(val)
          }else{
            return false;
          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/plugin/submit-form.vue